import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({

  content: {
    zIndex: 9,
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  mask: {
    background: `linear-gradient(to bottom, rgba(0,0,0,0) 0%, ${theme.palette.hover3} 100%);`,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    width: '100%',
    height: 100,
    position: 'absolute',
    left: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  knowledge: {
    background: '#fff',
    width: '100%',
    position: 'absolute',
    left: 0,
    padding: 15,
    borderTopLeftRadius: theme.shape.borderRadius * 2,
    borderTopRightRadius: theme.shape.borderRadius * 2,
  },
  knowledgeSuggestions: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
      width: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.primary.main,
    },
  },
  dropzone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingBottom: '300px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    transition: 'border .24s ease-in-out',
  },
  dropzoneText: {
     marginTop: '20px',
  },
}))

export default useStyles
